/*eslint-disable*/
import api from '../'

class couplesGameItems {
    // POST: couples
    static getCouplesByRequest (params) {
        return api.axios.post('/couplesByRequest', params).then(response => response.data.couples);
    }

    static getCouplesReadingEnByRequest (params) {
        return api.axios.post('/couplesReadingEnByRequest', params).then(response => response.data.couples);
    }

    static getSoundCouples (params) {
        return api.axios.post('/getSoundCouples', params).then(response => response.data.couples);
    }

    static getDigitCouples (params) {
        return api.axios.post('/getDigitCouples', params).then(response => response.data.couples);
    }
}

export default couplesGameItems;
